export default {
  title: 'Ordini',
};
